module.exports = __webpack_public_path__ + "img/5.18cff79a.jpg";